var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',_vm._b({staticClass:"team-avatar",class:{'is-default': _vm.isDefault},attrs:{"size":_vm.size}},'v-avatar',_vm.$attrs,false),[_c('img',{attrs:{"src":_vm.src || _vm.TeamDefaultAvatar,"alt":""},on:{"error":_vm.fallbackAvatar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }